import store from '@apply/adminStore';
import { LoanActionType } from '../../../common/LoanConstants';
import { executeLoanAction } from '../../../common/LoanFunctions';
import { Location } from 'react-router';

export const onCellDblClick = (e, location: Location) => {
    const { dispatch } = store;
    if (e.rowType !== 'data' || e.column.type === 'detailExpand' || e.column.type === 'actions') {
        return;
    }
    var model = {
        id: LoanActionType.Insurance,
        loanId: e.data.id,
        propertyId: e.data.propertyId,
    };
    executeLoanAction(model, dispatch, location);
};
